export enum UserType {
    ADMIN = 'Super Administrator',
}